import React, { useState } from 'react';
import { Editor } from './Editor';

export function safeParseBody(val) {
  if (!val) return { blocks: [] };
  if (typeof val === 'object') return val;
  try {
    const parsed = JSON.parse(val);
    return typeof parsed === 'object' && parsed !== null ? parsed : { blocks: [] };
  } catch {
    return { blocks: [] };
  }
}

/**
 * Wraps Editor.js and handles initialization from a serialized body value.
 * Props:
 *   value     - body to initialize from: Editor.js JSON string or parsed object (read once at mount)
 *   onChange  - called with raw Editor.js output object on every change
 *   websiteId - passed through to Editor for image uploads
 */
function RichTextEditor({ value, onChange, websiteId }) {
  const [editorData] = useState(() => {
    const body = safeParseBody(value);
    return { time: Date.now(), blocks: body.blocks || [] };
  });

  return <Editor data={editorData} onChange={onChange} websiteId={websiteId} />;
}

export default RichTextEditor;
